"use strict";
import _ from "underscore";
import Auth from "../util/auth";
const Account = {
  current: function() {
    const currentUser = Auth._currentUser;
    return currentUser && currentUser.account;
  },
  currentSettings: function() {
    if (this.notSignedIn()) {
      return {};
    }
    return this.current().settings || {};
  },
  externalIntegrations: function() {
    if (this.notSignedIn()) {
      return [];
    }
    return this.current().external_integrations || [];
  },
  shouldAssignDocumentsToCustomerLoads: function(settings) {
    return settings.document_assignment_strategy === "customer_load" || settings.document_assignment_strategy === "customer_load_and_delivery";
  },
  shouldAssignDocumentsToShipments: function(settings) {
    return settings.document_assignment_strategy === "shipment";
  },
  shouldDisplayShipmentLineItems: function() {
    return !!this.currentSettings()["display_shipment_line_items"];
  },
  paymentsNetworkEnabled: function() {
    return this.currentSettings().payments_network_enabled;
  },
  notSignedIn() {
    return !this.current();
  },
  hasRole: function(role) {
    if (this.notSignedIn()) return false;
    return _.chain(this.current().account_roles).pluck("type").contains(role).value();
  },
  overriddenAuditFlags() {
    return this.currentSettings().overridden_audit_flags;
  },
  nonInvoiceLoadDocumentTypes() {
    return this.currentSettings().non_invoice_load_document_types;
  },
  customerVisibleDocumentTypes() {
    return this.current().customer_visible_document_types;
  },
  indexAuditSplitEnabled() {
    return this.currentSettings().index_audit_split_enabled;
  },
  lazyLoadIndexerThumbnails() {
    return this.currentSettings().lazy_load_indexer_thumbnails;
  },
  showPodDispositionOnIndexing() {
    return this.currentSettings().show_pod_disposition_on_indexing;
  },
  podDefinitionModuleEnabled() {
    return this.currentSettings().pod_definition_module_enabled;
  },
  auditBillingEnabled() {
    return this.currentSettings().audit_billing_enabled;
  },
  carrierInvoiceCanModifyPaymentDueOn() {
    return this.currentSettings()["carrier_invoice_can_modify_payment_due_on"];
  },
  loadEmailSandboxRecipients() {
    const recipients = this.currentSettings().load_email_sandbox_recipients;
    if (_.isEmpty(recipients)) {
      return null;
    } else {
      return _.map(recipients.split(","), function(recipient) {
        return recipient.trim();
      });
    }
  },
  useSubmissionWorkflow() {
    return this.currentSettings()["submissionWorkflow"];
  },
  useFactorInvoiceWorkflowPage() {
    var _a, _b;
    return !!this.currentSettings()["feature_use_factor_invoice_workflow_page"] && !!((_b = (_a = Auth._currentUser) == null ? void 0 : _a.settings) == null ? void 0 : _b.use_factor_invoice_workflow_page);
  },
  useCarrierInvoiceWorkflowPage() {
    var _a, _b;
    return !!this.currentSettings()["feature_use_carrier_invoice_workflow_page"] && !!((_b = (_a = Auth._currentUser) == null ? void 0 : _a.settings) == null ? void 0 : _b.use_carrier_invoice_workflow_page);
  },
  useBothSubmissionWorkflows() {
    return this.currentSettings()["use_both_submission_and_traditional_workflow"];
  },
  useDocumentTypeHotkeys() {
    return !this.useSubmissionWorkflow();
  },
  shouldShowLineItems() {
    return this.shouldShowReadOnlyLineItems() || this.shouldShowEditableLineItems();
  },
  shouldShowReadOnlyLineItems() {
    return this.currentSettings().line_item_visibility === "read_only";
  },
  shouldShowEditableLineItems() {
    return this.currentSettings().line_item_visibility === "editable";
  },
  useSendToReceivables() {
    return this.currentSettings()["factor_allow_manual_send_to_receivables"] && this.current().receivables_account;
  },
  useBillingReqsPopout() {
    return this.currentSettings()["use_billing_reqs_popout"];
  },
  useDocumentViewerPopout() {
    return this.currentSettings()["use_document_viewer_popout"];
  },
  showAllLoadDocumentsEnabled() {
    return this.currentSettings()["show_all_load_docs_enabled"];
  },
  // NOTE: this is a short term solution.
  // next step is to get this actually using the api.
  carrierTerm() {
    return this.matchAccountType({
      broker: () => "Carrier",
      factor: () => "Client",
      forwarder: () => "Organization"
    });
  },
  carrierTermLower() {
    return this.carrierTerm().toLowerCase();
  },
  newFlowModeDebuggingEnabled() {
    return this.currentSettings().feature_enable_experimental_flow_mode_debugging;
  },
  isType(string) {
    const account = this.current();
    return account && account.get ? account.get(string) : account && account[string];
  },
  matchAccountType(accountTypes) {
    if (this.isType("forwarder_account")) {
      return accountTypes["forwarder"]();
    } else if (this.isType("factor_account")) {
      return accountTypes["factor"]();
    } else {
      return accountTypes["broker"]();
    }
  },
  processorSupportEmailAddress() {
    return this.currentSettings()["processor_support_email_address"];
  },
  indexShipmentAssignmentEnabled() {
    return this.currentSettings().index_shipment_assignment_enabled;
  },
  indexDeliveryAssignmentEnabled() {
    return this.currentSettings().index_delivery_assignment_enabled;
  },
  preventNidfToLoadWithCustomerCustomExceptionMessagesEnabled() {
    return this.currentSettings().prevent_nidf_to_load_with_customer_custom_rules;
  },
  automateCustomExceptionMessages() {
    return this.currentSettings().automate_customer_custom_exception_messages;
  }
};
export default Account;
